import { Navigate, Outlet } from 'react-router-dom-v5-compat';

import { ROLE_LEVELS, useAuthLevel } from '../../hooks/useCurrentUser';

// Gate for the credential-store routes, mounted INSIDE the v2 Shell. Mirrors
// HrGate: loader while the role hydrates (a redirect during hydration bounces
// refreshes), below manager level → dashboard. The API further scopes rows
// per-grant — this gate only keeps customers out of the page shell.
export default function CredentialsGate() {
    const level = useAuthLevel();

    if (level === undefined) {
        return (
            <div className="flex h-64 w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
                Se incarca...
            </div>
        );
    }
    if (level < ROLE_LEVELS.MANAGER) return <Navigate to="/v2/dashboard" replace />;
    return <Outlet />;
}
